module.exports = __webpack_public_path__ + "media/Eclipse.67fd7196.mp3";